export default __webpack_public_path__ + "media/images/halloween/spider-4260f34f4c77bce2713728934578cb8c.svg";